<app-header></app-header>
<app-navbar [selected]="'administration'"></app-navbar>


<div class="d-flex">
    <aside role="complementary" [attr.aria-label]="'asideDescription' | translate">
        <app-sidebar [items]="links"></app-sidebar>
    </aside>
    <main class="ps-5 w-100 ">
        <div class="row mb-3">
            <div class="col-md-6 fw-bold">
                <label for="basic-url" class="form-label color-text"> {{ 'language.langs' | translate }} </label>
            </div>
            <div class="col-md-6 text-end">
                <button type="button" class="btn custombutton" (click)="checkRow()">{{ 'language.newLanguage' |
                    translate }}</button>
            </div>
        </div>
        @if(this.languageResponse.languageDto.length > 0){
        <div class="row">
            <fieldset>
                <table class="table text-center" role="table" [attr.aria-label]="'language.langs' | translate">
                    <thead>
                        <tr role="row">
                            <th scope="col" role="columnheader">
                                <span class="visually-hidden">{{ 'seleccionarFila' | translate }}</span>
                            </th>
                            <th scope="col" role="columnheader">{{ 'language.code' | translate }}</th>
                            <th scope="col" role="columnheader">{{ 'language.name' | translate }}</th>
                            <th scope="col" role="columnheader">{{ 'language.state' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (lan of languageResponse.languageDto; track $index) {
                        <tr role="row" [ngClass]="{'resaltado': selectedRowId === lan.code}">
                            <td role="gridcell">
                                <input type="radio" id="radio-{{lan.code}}" name="flexRadioDefault"
                                    [checked]="selectedRowId === lan.code" (click)="checkRow(lan)" />
                                <label [for]="'radio-' + lan.code" class="visually-hidden">
                                    {{ "seleccionarFilaCon" | translate }}:
                                    {{ 'language.code' | translate }} {{ lan.code }},
                                    {{ 'language.name' | translate }} {{ lan.name }},
                                    {{ 'language.state' | translate }} {{ lan.active ? ('model.active' | translate) :
                                    ('model.inactive' | translate) }}
                                </label>
                            </td>
                            <td role="gridcell">{{lan.code}}</td>
                            <td role="gridcell">{{lan.name}}</td>
                            <td role="gridcell">{{lan.active ? ('model.active' | translate) : ('model.inactive' |
                                translate)}}</td>
                        </tr>
                        }
                    </tbody>
                </table>
            </fieldset>


            <div class="mt-2" *ngIf="this.languageResponse.pageDto">
                <app-paginator [isStart]="this.languageResponse.pageDto.start"
                    [isEnd]="this.languageResponse.pageDto.end"
                    [currentPage]="this.languageResponse.pageDto.currentPage"
                    [totalPages]="this.languageResponse.pageDto.pages"
                    [numberRecord]="this.languageResponse.pageDto.records"
                    [sizePage]="this.languageResponse.pageDto.pageSize">
                </app-paginator>
            </div>
            @if(this.selectedRowId !== '' || this.createLanguage){
            <div class="separator mt-5"></div>
            <div>
                <form [formGroup]="validateLanguageForm" (ngSubmit)="createOrUpdateLanguage()">
                    <div class="mt-5">
                        @if(this.createLanguage) {
                        <h2 class="textformat mb-4 color-text"> {{ 'language.newLanguage'
                            | translate }} </h2>
                        }@else {
                        <h2 class="textformat mb-4 color-text"> {{
                            'language.updateLanguage' | translate }} </h2>
                        }
                    </div>

                    <div class="row">
                        <div class="col-md-3 mb-3 color-text">
                            <label class="form-label" for="code"> {{ 'language.code' | translate }} <span>
                                    *</span></label>
                            <input id="code" name="code" type="text" class="form-control color-text" placeholder="Code"
                                formControlName="code">
                        </div>

                        <div class="col-md-3 mb-3 color-text">
                            <label class="form-label" for="name"> {{ 'language.name' | translate }} <span>
                                    *</span></label>
                            <input id="name" name="name" type="text" class="form-control color-text" placeholder="Name"
                                formControlName="name">
                        </div>

                        <div class="col-md-3 mb-3 color-text">
                            <label class="form-label" for="isDefault">{{ 'language.langeDefault' | translate
                                }}:</label>
                            <select class="form-select  modelinput-flex" aria-label="Select language"
                                formControlName="isDefault" id="isDefault" name="isDefault">
                                <option [value]="true"> {{ 'language.optionYes' | translate }} </option>
                                <option [value]="false"> {{ 'language.optionNo' | translate }} </option>
                            </select>
                        </div>
                        <div class="col-md-3 mb-3 color-text modelinput-flex">
                            <label class="form-label" for="active"> {{ 'language.langActive' | translate }}:</label>
                            <select class="form-select" id="active" name="active" aria-label="Language active"
                                formControlName="active">
                                <option value=""></option>
                                <option [value]="true"> {{ 'language.optionYes' | translate }} </option>
                                <option [value]="false"> {{ 'language.optionNo' | translate }} </option>
                            </select>
                        </div>
                    </div>
                    @if (this.createLanguage) {
                    <button type="submit" class="btn custombutton mt-3"> {{ 'language.createLanguage' | translate }}
                    </button>
                    }@else {
                    <button type="submit" class="btn custombutton mt-3 mx-2"> {{ 'language.updateLanguage' |
                        translate
                        }} </button>
                    }
                </form>
            </div>
            }

            <app-alert-component [isOk]="messageVisibility.isSuccessFirst" [isDanger]="messageVisibility.isErrorFirts"
                [message]="errorMessage"
                (close)="messageVisibility.isSuccessFirst = messageVisibility.isErrorFirts = false"></app-alert-component>
        </div>
        }@else {
        <div class="alert" role="alert" style="background-color: #73EDFF;">
            There are no langauges for the application
        </div>
        }
    </main>

</div>